/** What a message template's placeholders are filled with. */
export interface MessageVars {
  name?: string | null;
  /** The document number. */
  number?: string | null;
  /** Already formatted. */
  amount?: string | null;
  /** Already formatted. */
  date?: string | null;
  shop?: string | null;
}

/** The placeholders a shop can use in its messages (Settings → WhatsApp). */
export const PLACEHOLDERS: { key: keyof MessageVars; label: string }[] = [
  { key: 'name', label: 'customer or supplier name' },
  { key: 'number', label: 'document number' },
  { key: 'amount', label: 'total' },
  { key: 'date', label: 'document date' },
  { key: 'shop', label: 'shop name' },
];

/** Fills {name}, {number}, … in a template; a placeholder without a value is left out. */
export function fillTemplate(template: string, vars: MessageVars): string {
  return template
    .replace(/\{(name|number|amount|date|shop)\}/g, (_, k: keyof MessageVars) => vars[k] ?? '')
    .replace(/[ \t]+([,.])/g, '$1')
    .replace(/\bDear\s*,/g, 'Hello,')
    .trim();
}
